import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  PLATFORM_ID,
  SimpleChanges,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FilterComponent } from '../../molecules/filter/filter.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { News } from '../../../shared/interfaces/news.interface';
import BadgeType from '../../../shared/enums/badge-type.enums';
import { DropdownType } from '../../../shared/enums/dropdown-type.enums';
import { CapitalizePipe } from '../../capitalize.pipe';
import { ErrorHandlerService } from '../../../services/error-handler.service';
import { safeAssign } from '../../../shared/utils/safe-assign.util';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'hdi-filter-bar',
  standalone: true,
  imports: [
    CommonModule,
    FilterComponent,
    DropdownComponent,
    CapitalizePipe,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class FilterBarComponent implements OnInit, OnChanges {
  @Input() news: News[] = [];
  @Input() caasFilters?: { filter: string; categories: string[] }[];
  @Output() filteredNews = new EventEmitter<News[]>();
  public filters: string[] = [];
  public selectedFilter: string = 'Alle';
  public selectedFilterCaas?: { filter: string; categories: string[] };
  public isLoading = true;

  BadgeType = BadgeType;
  DropdownType = DropdownType;

  constructor(
    private errorHandler: ErrorHandlerService,
    @Inject(PLATFORM_ID) private readonly platformId: object
  ) {}
  ngOnInit(): void {
    if (!this.caasFilters) {
      safeAssign(
        () => {
          this.filters = this.getCategoriesNews();
        },
        'Set filters',
        this.errorHandler
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasFilters']) {
      let categories: string[] = [];
      this.caasFilters = changes['caasFilters'].currentValue;
      safeAssign(
        () => {
          categories = this.getCategoriesNews();
        },
        'Get categories',
        this.errorHandler
      );
      safeAssign(
        () => {
          this.caasFilters = this.caasFilters?.filter((filter) =>
            filter.categories.some((category) => categories.includes(category))
          );
        },
        'Filter caasFilters',
        this.errorHandler
      );
      if (isPlatformBrowser(this.platformId)) {
        this.isLoading = false;
      }
    }
  }

  get filtersMobile(): string[] {
    if (!this.caasFilters) {
      return ['Alle', ...this.filters];
    } else {
      return ['Alle', ...this.caasFilters.map((filter) => filter.filter)];
    }
  }

  getCategoriesNews(): string[] {
    return this.news
      .flatMap((news) =>
        news.badges.filter((badge) => badge.type === BadgeType.DEFAULT)
      )
      .map((badge) => badge.label)
      .filter(
        (label, index, self) => index === self.findIndex((l) => l === label)
      );
  }

  handleClick(label: string) {
    this.selectedFilter = label;
    if (!this.caasFilters) {
      this.filteredNews.emit(this.filterNews());
    } else {
      this.selectedFilterCaas = this.caasFilters?.find(
        (filter) => filter.filter === label
      );
      this.filteredNews.emit(this.filterNewsCaas());
    }
  }

  filterNews() {
    if (this.selectedFilter === 'Alle') {
      return this.news;
    } else {
      return this.news.filter((news) =>
        news.badges.some((badge) => badge.label === this.selectedFilter)
      );
    }
  }

  filterNewsCaas() {
    if (this.selectedFilter === 'Alle') {
      return this.news;
    } else {
      return this.news.filter((news) =>
        news.badges.some((badge) =>
          this.selectedFilterCaas?.categories.includes(badge.label)
        )
      );
    }
  }
}
